module.exports = "/_next/static/images/4c67d9e27c7d3dc3548957d7b8bbb855-complexity@xs-1x.jpg";